import {mapTradeWriteToDbUpdate, TradeWrite} from '@cp/model';
import {updateDoc} from 'firebase/firestore';
import {getCurrentUserIdValidated} from '../../config/firebaseUser';
import {getTradeDocRef} from './getTradeDocRef';

/**
 * Update a trade
 * - messages are appended to the trade
 * @param id - trade id
 * @param input - trade fields to update
 */
export async function updateTrade(id: string, input: Partial<TradeWrite>): Promise<void> {
  const uid = await getCurrentUserIdValidated();
  const ref = getTradeDocRef(uid, id);
  const mapped = mapTradeWriteToDbUpdate(input);
  await updateDoc(ref, mapped);
}
